import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { baseUniDriverFactory } from '../../testkitUtils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';

export interface ThreeDotsLoaderDriver extends BaseUniDriver {}

export const threeDotsLoaderDriverFactory = (
  base: UniDriver,
): ThreeDotsLoaderDriver => {
  return {
    ...baseUniDriverFactory(base),
  };
};
